import { React, useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../../contexts/authContext';
import { Link, useNavigate } from 'react-router-dom';

import { useDisclosure } from '@mantine/hooks';
import { Avatar, Loader, Modal, Group, Button, TextInput, Textarea } from '@mantine/core';
import { IconUser, IconAt, IconId, IconUserShield, IconShieldExclamation, IconChevronLeft } from '@tabler/icons-react';

import AppHdWithReturnLeft from '../../../../composents/Headers/AppHeaders/AppHdWithReturnLeft/AppHdWithReturnLeft';
import SyndicRectangleButtonSnd from '../../../../composents/Buttons/Syndic/RectangleButton/RectangleButtonSecond';
import LogoutButton from '../../../../composents/Buttons/All/Logout/Logout';
import AppDesktopLogo from '../../../../composents/Logo/AppDesktopLogo/AppDesktopLogo';

const UserAccount = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const { handleLogoutSyndic, getToken } = useContext(AuthContext);
    const [ openedLogoutModal, { open: openLogoutModal, close: closeLogoutModal}] = useDisclosure(false)
    const [ userData, setUserData ] = useState(null)
    const [role, setRole] = useState("");
    const [ openedRoleModal, { open: openRoleModal, close: closeRoleModal}] = useDisclosure(false)
    const [no, setNo] = useState("");
    const [street, setStreet] = useState("");
    const [postalcode, setPostalcode] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("France");
    const [ openedAddressModal, { open: openAddressModal, close: closeAddressModal}] = useDisclosure(false)
    const [description, setDescription] = useState("");
    const [ openedActivityModal, { open: openActivityModal, close: closeActivityModal}] = useDisclosure(false)
    
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }
        getUser();
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const getUser = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/getUser', {
                method: "GET",    
                headers: {
                    Authorization: `Bearer ${token}`
                }
        });
            const data = await response.json();
            setUserData(data);
        }   catch (error) {
            return null;
        }
    };

    const handleOpenLogoutModal = () => {
        openLogoutModal()
    };

    const handlecloseValidationModal = () => {
        closeLogoutModal()
    };

    const handleLogout = async () => {
        await handleLogoutSyndic();
        navigate("/app/login");
    };

    const requiredFields = ["street", "postalcode", "city", "country"];

    const isAddressComplete =
    userData?.company?.address &&
    requiredFields.every(
        (field) =>
        userData.company.address[field] &&
        userData.company.address[field].toString().trim() !== ""
    );

    const handleRoleSubmit = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!role || role.trim().length < 2) return;

            const response = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/app/profile/addRole", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ role }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message);
            }
            closeRoleModal();
            setRole("");
            window.location.reload();

        } catch (error) {
            console.error(error.message);
        }
    };

    const formatText = (value) => {
        if (!value) return "";
        const trimmed = value.trim().toLowerCase();
        return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
    };

    const handleAddressSubmit = async () => {
        try {
            const token = localStorage.getItem("token");
            // if (!street || !postalcode || !city || !country) return;
            const formattedStreet = formatText(street);
            const formattedCity = formatText(city);
            const formattedCountry = formatText(country);

            const response = await fetch(
            "https://boldee-97d8d36af3bd.herokuapp.com/app/profile/addAddress",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify({
                    no : no || "",
                    street: formattedStreet,
                    postalcode,
                    city: formattedCity,
                    country: formattedCountry,
                }),
            }
            );

            const data = await response.json();
            console.log("STATUS:", response.status);
            console.log("RESPONSE DATA:", data);

            if (!response.ok) {
                throw new Error(data.message);
            }

            closeAddressModal();
            setNo("");
            setStreet("");
            setPostalcode("");
            setCity("");
            setCountry("France");
            window.location.reload();

        } catch (error) {
            console.error(error.message);
        }
    };
    
    const handleDescriptionSubmit = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!description || description.trim().length < 10) return;

            const response = await fetch(
            "https://boldee-97d8d36af3bd.herokuapp.com/app/profile/addCompanyDescription",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify({ description }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message);
            }

            closeActivityModal();
            setDescription("");
            window.location.reload();


        } catch (error) {
            console.error(error.message);
        }
    };

    return(
        userData ?
            <>
                {isMobile ? (
                    <>
                        <AppHdWithReturnLeft>Mon compte</AppHdWithReturnLeft>    
                        <div className="vertical iCenter">
                            {userData.avatar
                                ? <Avatar src={userData.avatar} alt="avatar" radius={50} size={100} />
                                : <div className="noAvatarProfileAccount">{userData.firstname.charAt(0)}{userData.lastname.charAt(0)}</div>
                            }
                            
                            <div className="mrgB10"></div>

                            <div  className="width90pCenter vertical mrgT10 mrgB10">
                                <div className='horizontal'>
                                    <div className="vertical">
                                        <div className='horizontal'>
                                            <p className="txt18 medium noMrgTB mrgR5">{userData.firstname}</p>
                                            <p className="txt18 medium noMrgTB capitals">{userData.lastname}</p>
                                        </div>
                                        {userData.occupation 
                                            ? <p className='noMrg txt15'>{userData.occupation}</p>
                                            : <div>
                                                    <p className='noMrgTB'>Fonction non renseignée</p>
                                                    <Button color='dark' radius='xl' className='mrgT5 mrgB5' onClick={() => openRoleModal(true)}>
                                                        Ajouter ma fonction
                                                    </Button>

                                                    <Modal
                                                        opened={openedRoleModal}
                                                        onClose={() => closeRoleModal(false)}
                                                        title="Ajouter votre fonction"
                                                        centered
                                                        size="xs"
                                                    >
                                                        <TextInput
                                                            label="Fonction"
                                                            placeholder="Ex : Responsable des achats"
                                                            value={role}
                                                            onChange={(e) => setRole(e.currentTarget.value)}
                                                        />

                                                        <Button
                                                            fullWidth
                                                            mt="xs"
                                                            onClick={handleRoleSubmit}
                                                            disabled={!role}
                                                            color='dark'
                                                            >
                                                            Enregistrer
                                                        </Button>
                                                    </Modal>
                                             </div>
                                        }
                                        <p className="noMrg txt15 dGreyT">{userData.email}</p>
                                    </div>
                                </div>
                                <div className='topBorder mrgT20'>
                                    {userData.company
                                        ?   
                                            <div className='vertical'>
                                                <p className="txt18 medium noMrgB capitals">{userData.company.name}</p>
                                                {isAddressComplete
                                                    ? 
                                                        <div>
                                                            <p className="txt15 noMrgTB">{userData.company.address.no ? `${userData.company.address.no}, ` : ''}{userData.company.address.street}</p>
                                                            <p className="txt15 noMrgTB">{userData.company.address.postalcode} {userData.company.address.city}</p>
                                                            <div className='horizontal iCenter mrgT5 txt13'>
                                                                <IconUserShield width={15} className='mrgR5'/>
                                                                Identité vérifiée
                                                            </div>
                                                        </div>
                                                    : 
                                                        <div className='vertical'>
                                                            <p className='noMrgTB'>Une adresse valide est obligatoire</p>
                                                            <Button color='dark' radius='xl' className='mrgT5' onClick={() => openAddressModal()}>
                                                                <IconShieldExclamation width={20} className='mrgR5'/>
                                                                Ajouter adresse
                                                            </Button>

                                                            <Modal
                                                                opened={openedAddressModal}
                                                                onClose={closeAddressModal}
                                                                title="Ajouter l’adresse de l’entreprise"
                                                                centered
                                                                size="md"
                                                                >
                                                                <TextInput
                                                                    label="N°"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    value={no}
                                                                    onChange={(e) =>
                                                                        setNo(e.currentTarget.value.replace(/[^0-9]/g, ""))
                                                                    }
                                                                />

                                                                <TextInput
                                                                    mt="xs"
                                                                    label="Adresse complète"
                                                                    placeholder="Ex : rue de Paris"
                                                                    value={street}
                                                                    onChange={(e) => setStreet(e.currentTarget.value)}
                                                                    required
                                                                />

                                                                <TextInput
                                                                    mt="xs"
                                                                    label="Code postal"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    maxLength={5}
                                                                    value={postalcode}
                                                                    onChange={(e) =>
                                                                        setPostalcode(
                                                                        e.currentTarget.value
                                                                            .replace(/[^0-9]/g, "")
                                                                            .slice(0, 5)
                                                                        )
                                                                    }
                                                                    required
                                                                />

                                                                <TextInput
                                                                    mt="xs"
                                                                    label="Ville"
                                                                    value={city}
                                                                    onChange={(e) => setCity(e.currentTarget.value)}
                                                                    required
                                                                />

                                                                <TextInput
                                                                    mt="xs"
                                                                    label="Pays"
                                                                    value={country}
                                                                    onChange={(e) => setCountry(e.currentTarget.value)}
                                                                    required
                                                                />

                                                                <Button
                                                                    fullWidth
                                                                    mt="md"
                                                                    onClick={() => {
                                                                        console.log("CALLING FUNCTION");
                                                                        handleAddressSubmit();
                                                                    }}                                                              
                                                                    // disabled={!street || !postalcode || !city || !country}
                                                                    color='dark'
                                                                >
                                                                    Enregistrer l’adresse
                                                                </Button>
                                                                </Modal>

                                                        </div>
                                                }
                                            </div>
                                        :   ""
                                    }
                                </div>
                                {userData.company.description
                                    ? 
                                        <div className='mrgT20'>
                                            <p className="txt16 medium noMrgTB mrgR5">À propos de {userData.company.name}</p>
                                            <p>{userData.company.description}</p>
                                        </div>
                                    
                                    :  <div className='mrgT20 vertical'>
                                            <p className='noMrgTB'>Complétez votre présentation pour améliorer votre attractivité auprès des acheteurs et fournisseurs.</p>
                                            <Button color='dark' radius='xl' className='mrgT5' onClick={() => openActivityModal(true)}>
                                                Ajouter une description
                                            </Button>

                                            <Modal
                                                opened={openedActivityModal}
                                                onClose={closeActivityModal}
                                                title={`Ajouter la description de ${userData?.company?.name || "l’entreprise"}`}
                                                centered
                                                >
                                                <Textarea
                                                    placeholder="Présentez votre activité, vos services et votre expertise."
                                                    autosize
                                                    minRows={18}
                                                    maxLength={200}
                                                    value={description}
                                                    onChange={(e) => setDescription(e.currentTarget.value)}
                                                    description={`${description.length}/200 caractères`}
                                                />

                                                <Button
                                                    fullWidth
                                                    mt="md"
                                                    onClick={handleDescriptionSubmit}
                                                    disabled={!description || description.trim().length < 10 || description.length > 200}
                                                    color='dark'
                                                >
                                                    Enregistrer
                                                </Button>
                                                </Modal>
                                        </div>
                                }
                                <div className='mrgT20'>

                                </div>

                            </div>
                                                    

                            <div className ="width90pCenter">
                            {userData.company
                                ? <Link to={`/app/profile/edit`}>
                                        <SyndicRectangleButtonSnd>
                                            Modifier
                                        </SyndicRectangleButtonSnd>
                                    </Link>
                                : ""
                            }
                                <div className="mrgB10"></div>

                                <LogoutButton
                                    onClick= {handleOpenLogoutModal}>
                                    Déconnexion
                                </LogoutButton>
                                <div className="mrgB20"></div>
                                {openLogoutModal
                                    ?   <Modal 
                                            centered
                                            withCloseButton={false}    
                                            opened={openedLogoutModal} 
                                            onClose={closeLogoutModal}
                                            size="auto">
                                                <Group noWrap mt="md" className=" txtCenter mrgT5 txt15">
                                                        Êtes-vous sûr de vouloir vous déconnecter ?
                                                </Group>
                                                <Group mt="xl" className="txtCenter horizontal spaceArd mrgT20 w80">
                                                <Button variant="outline" color="dark" onClick={handlecloseValidationModal}>
                                                    Annuler
                                                </Button>
                                                <Button variant="filled" color="dark"  onClick={handleLogout} className=' medium'>
                                                    Déconnecter
                                                </Button>
                                            </Group>       
                                        </Modal> 
                                    :   ""
                                }
                            </div>
                        </div>    
                    </>
                ) : (
                    <>
                        <AppDesktopLogo/>
                        <div className="offer-desktop-page-bg" style={{ padding: "0 0 60px", alignItems: "flex-start", flexDirection: "column" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", margin: "40px auto 20px", width: "39%" }}>
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                style={{
                                    height: 36,
                                    width: 110,
                                    opacity: 0.9,
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: 50,
                                    border: "none",
                                    padding: "0 12px",
                                    boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                                    cursor: "pointer",
                                    justifySelf: "start",
                                }}
                            >
                                <div className="horizontal iCenter">
                                    <IconChevronLeft width={20} />
                                    <p className="txt18 medium noMrgTB mrgL5">Retour</p>
                                </div>
                            </button>
                            <h2 className="noMrgTB" style={{ gridColumn: 2, justifySelf: "center" }}>Mon compte</h2>
                            <div />
                        </div>
                        <div className="offer-form-card vertical" style={{ width: "39%" }}>
                            <div className="horizontal jCenter">
                                <Avatar src={userData.avatar} alt="avatar" radius={50} size={100} />
                            </div>
                            <div className="mrgB10"></div>
                            
                            <div className="vertical mrgT20 mrgB10">
                                <div className='horizontal mrgT10'>
                                        <p className="noMrgTB mrgR20"><IconUser width={29} height={27}/></p>
                                        <div className="vertical">
                                            <div className='horizontal mrgB5'>
                                                <p className="txt20 medium noMrgTB mrgR5">{userData.firstname}</p>
                                                <p className="txt20 medium noMrgTB capitals">{userData.lastname}</p>
                                            </div>
                                            {userData.occupation
                                                ? <p className='noMrg txt18'>{userData.occupation}</p>
                                                : <div>
                                                        <p className='noMrgTB txt18'>Fonction non renseignée</p>
                                                        <Button color='dark' radius='xl' size='md' className='mrgT5 mrgB5' onClick={() => openRoleModal(true)}>
                                                            <p className='txt16 noMrgTB'>Ajouter ma fonction</p>
                                                        </Button>

                                                        <Modal
                                                            opened={openedRoleModal}
                                                            onClose={() => closeRoleModal(false)}
                                                            title="Ajouter votre fonction"
                                                            centered
                                                            size="xs"
                                                        >
                                                            <TextInput
                                                                label="Fonction"
                                                                placeholder="Ex : Responsable des achats"
                                                                value={role}
                                                                onChange={(e) => setRole(e.currentTarget.value)}
                                                            />

                                                            <Button
                                                                fullWidth
                                                                mt="xs"
                                                                onClick={handleRoleSubmit}
                                                                disabled={!role}
                                                                color='dark'
                                                                >
                                                                Enregistrer
                                                            </Button>
                                                        </Modal>
                                                 </div>
                                            }
                                        </div>
                                </div>

                                {userData.company
                                    ?   <div className="horizontal iStart mrgB20 mrgT20">
                                            <p className="noMrgTB mrgR20"><IconId  width={29} height={23}/></p>
                                            <div className='vertical noMrgT'>
                                                <p className="txt20 medium noMrgT mrgB5 capitals">{userData.company.name}</p>
                                                {isAddressComplete
                                                    ? <>
                                                        <p className="txt18 noMrgTB">{userData.company.address.no ? `${userData.company.address.no}, ` : ''}{userData.company.address.street}</p>
                                                        <p className="txt18 noMrgTB">{userData.company.address.postalcode} {userData.company.address.city}</p>
                                                        <div className='horizontal iCenter mrgT5 txt15'>
                                                            <IconUserShield width={17} className='mrgR5'/>
                                                            Identité vérifiée
                                                        </div>
                                                      </>
                                                    : <div className='vertical'>
                                                        <p className='noMrgTB txt18'>Une adresse valide est obligatoire</p>
                                                        <Button color='dark' radius='xl' size='md' className='mrgT5' onClick={() => openAddressModal()}>
                                                            <IconShieldExclamation width={20} className='mrgR5'/>
                                                            <p className='txt16 noMrgTB'>Ajouter adresse</p>
                                                        </Button>

                                                        <Modal
                                                            opened={openedAddressModal}
                                                            onClose={closeAddressModal}
                                                            title="Ajouter l’adresse de l’entreprise"
                                                            centered
                                                            size="md"
                                                            >
                                                            <TextInput
                                                                label="N°"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={no}
                                                                onChange={(e) =>
                                                                    setNo(e.currentTarget.value.replace(/[^0-9]/g, ""))
                                                                }
                                                            />

                                                            <TextInput
                                                                mt="xs"
                                                                label="Adresse complète"
                                                                placeholder="Ex : rue de Paris"
                                                                value={street}
                                                                onChange={(e) => setStreet(e.currentTarget.value)}
                                                                required
                                                            />

                                                            <TextInput
                                                                mt="xs"
                                                                label="Code postal"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                maxLength={5}
                                                                value={postalcode}
                                                                onChange={(e) =>
                                                                    setPostalcode(
                                                                    e.currentTarget.value
                                                                        .replace(/[^0-9]/g, "")
                                                                        .slice(0, 5)
                                                                    )
                                                                }
                                                                required
                                                            />

                                                            <TextInput
                                                                mt="xs"
                                                                label="Ville"
                                                                value={city}
                                                                onChange={(e) => setCity(e.currentTarget.value)}
                                                                required
                                                            />

                                                            <TextInput
                                                                mt="xs"
                                                                label="Pays"
                                                                value={country}
                                                                onChange={(e) => setCountry(e.currentTarget.value)}
                                                                required
                                                            />

                                                            <Button
                                                                fullWidth
                                                                mt="md"
                                                                onClick={handleAddressSubmit}
                                                                color='dark'
                                                            >
                                                                Enregistrer l’adresse
                                                            </Button>
                                                            </Modal>
                                                      </div>
                                                }
                                            </div>
                                        </div>
                                    :   ""
                                }

                                <div className="horizontal iCenter">
                                    <p className="noMrgTB mrgR20"><IconAt width={29} height={23}/></p>
                                    <p className="txt18 noMrgTB">{userData.email}</p>
                                </div>
                                <div className='mrgB20'></div>

                                {userData.company && (
                                    userData.company.description
                                        ? <div className='mrgT10'>
                                            <p className="txt18 medium noMrgTB mrgB5">À propos de {userData.company.name}</p>
                                            <p className='txt18 noMrgTB'>{userData.company.description}</p>
                                          </div>
                                        : <div className='mrgT10 vertical'>
                                            <p className='noMrgTB txt18'>Complétez votre présentation pour améliorer votre attractivité auprès des acheteurs et fournisseurs.</p>
                                            <Button color='dark' radius='xl' size='md' className='mrgT5' onClick={() => openActivityModal(true)}>
                                                <p className='txt16 noMrgTB'>Ajouter une description</p>
                                            </Button>

                                            <Modal
                                                opened={openedActivityModal}
                                                onClose={closeActivityModal}
                                                title={`Ajouter la description de ${userData?.company?.name || "l’entreprise"}`}
                                                centered
                                                >
                                                <Textarea
                                                    placeholder="Présentez votre activité, vos services et votre expertise."
                                                    autosize
                                                    minRows={10}
                                                    maxLength={200}
                                                    value={description}
                                                    onChange={(e) => setDescription(e.currentTarget.value)}
                                                    description={`${description.length}/200 caractères`}
                                                />

                                                <Button
                                                    fullWidth
                                                    mt="md"
                                                    onClick={handleDescriptionSubmit}
                                                    disabled={!description || description.trim().length < 10 || description.length > 200}
                                                    color='dark'
                                                >
                                                    Enregistrer
                                                </Button>
                                                </Modal>
                                          </div>
                                )}
                            </div>


                            <div className="mrgB20"></div>

                            <div className="vertical iCenter">
                                {userData.company
                                    ? <Link to={`/app/profile/edit`}>
                                        <Button
                                            color="dark"
                                            radius="xl"
                                            size="md"
                                            w={200}
                                            styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                        >
                                            Modifier
                                        </Button>
                                      </Link>
                                    : ""
                                }

                                <div className="mrgB20"></div>

                                <Button
                                    variant="outline"
                                    color="gray"
                                    radius="xl"
                                    size="md"
                                    w={200}
                                    styles={{ root: { borderColor: "#A1A1A1" }, label: { fontSize: 16, fontWeight: 500, color: "#A1A1A1" } }}
                                    onClick={handleOpenLogoutModal}
                                >
                                    Déconnexion
                                </Button>
                                {openLogoutModal  
                                    ?   <Modal 
                                            centered
                                            withCloseButton={false}    
                                            opened={openedLogoutModal} 
                                            onClose={closeLogoutModal}
                                            size="auto">
                                                <Group noWrap mt="md" className=" txtCenter mrgT10 txt18">
                                                        Êtes-vous sûr de vouloir vous déconnecter ?
                                                </Group>
                                                <Group mt="xl" className="txtCenter horizontal spaceArd mrgT20">
                                                <Button size='md' variant="outline" color="dark" onClick={handlecloseValidationModal}>
                                                    <p className='txt18'>Annuler</p>
                                                </Button>
                                                <Button size='md' variant="filled" color="dark"  onClick={handleLogout} className=' medium'>
                                                    <p className='txt18'>Déconnecter</p>
                                                </Button>
                                            </Group>       
                                        </Modal> 
                                    :   ""
                                }
                                <div className='mrgB30'></div>
                            </div>
                        </div>
                        </div>
                    </>
                )}
            </>
        : 
        <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className='mrgT5'>Chargement ...</div>
        </div>
    )
}   

export default UserAccount;

